<div class="modals return" [class.modals-show]="isModalReturnsShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="returns">
    <h4>Повернення</h4>
    <p>Повернення товару можливе <span class="alert bold">протягом 14 днів</span> з моменту придбання.</p>
    <b>Повернення відбувається наступними способами:</b>
    <ul>
      <li>Передача товару на складі самовивозу</li>
      <li>Передача товару водієві в день доставки</li>
      <li>Відправка Новою Поштою в м. Київ на відділення 191. Одержувач - Тополюк Анатолій 0683911344.</li>
      <li><span class="alert bold">Доставку сплачує відправник.</span></li>
      <li (click)="openModalReturnsInformation()"><span class="alert bold info-style">Детальна інформація</span>
        <i class="fa fa-info-circle"></i>
    </ul>
  </div>

  <div class="row">
    <div class="column text-center">
      <a href="/orders" class="button btn-return">Сформувати заявку на повернення</a>
    </div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
